/*------------------------------------*\
    PASTE WARNING
\*------------------------------------*/
class PasteWarning {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.elem.addEventListener('paste', evt => {
            alert('When copy and pasting, please be sure to double check your answers before submitting.');
        });
    }
}

export default PasteWarning;